import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, Text } from '@library';
import SidePane from '../../../core/components/SidePane';
import type { MetaProduct, RenditionUrl } from '../../types';
import ProductImage from '../ProductImage/ProductImage';
import styles from './MetaProductDetailsSidePane.module.scss';

const MetaProductDetailsSidePane = ({
    product,
    onClose,
}: {
    product: MetaProduct;
    onClose: () => void;
}) => {
    return (
        <SidePane
            side="right"
            header={<Heading h3>{product.model}</Heading>}
            onClose={onClose}
        >
            <div>
                <div className={styles.imagesGrid}>
                    {product.images?.map(image => (
                        <div
                            className={styles.imageTile}
                            key={image.rendition176pxUrl}
                        >
                            <ProductImage
                                size="176px"
                                url={
                                    image.rendition176pxUrl.replace(
                                        '176px',
                                        '*'
                                    ) as RenditionUrl
                                }
                            />
                        </div>
                    ))}
                </div>
                <div className={styles.propertiesTitle}>
                    <Heading h3>
                        <FormattedMessage id="Properties" />
                    </Heading>
                </div>
                <div className={styles.propertiesGrid}>
                    {product.specificationAttributes?.map(item => (
                        <>
                            <Text tertiary regular>
                                {item.name}
                            </Text>
                            <Text tertiary medium>
                                {item.value}
                            </Text>
                        </>
                    ))}
                </div>
            </div>
        </SidePane>
    );
};

export default memo(MetaProductDetailsSidePane);
